<template>
  <div class="select-none m-auto justify-center z-30 fixed inset-x-0 inset-y-0 h-5/6 w-5/6 bg-white rounded-3xl hover:cursor-default font-text overflow-scroll">
    <div class="flex flex-col h-full">
      <div class="my-2 items-center">
        <div class="flex flex-row">
          <p class="ml-auto flex-initial text-default text-2xl">{{ title }}</p>
          <p v-if="status !== ''" class="mr-auto flex-initial text-default text-2xl">&nbsp;- {{ status }}</p>
        </div>
      </div>
      <div class="flex flex-row items-centern content-center">
        <div v-if="attachmentOne !== null" class="w-1/2 my-2 flex flex-row items-center">
          <div class="text-default hover:text-link cursor-pointer mx-auto">
            <Icon :icon="attachmentOne[2]"/>
            <a :href="attachmentOne[0]" target="_blank" rel="noopener noreferrer" class="my-2 text-xl">&nbsp;<u>{{ attachmentOne[1] }}</u></a>
          </div>
        </div>
        <div v-if="attachmentTwo !== null" class="w-1/2 my-2 flex flex-row items-center">
          <div class="text-default hover:text-link cursor-pointer mx-auto">
            <Icon :icon="attachmentTwo[2]" />
            <a class="my-2 text-xl" :href="attachmentTwo[0]" target="_blank" rel="noopener noreferrer">&nbsp;<u>{{ attachmentTwo[1] }}</u></a>
          </div>
        </div>
      </div>
      <div class="items-center">
        <div class="flex flex-col my-auto text-default mx-12 text-lg text-left" v-html="desc"></div>
      </div>
      <div class="my-auto flex flex-row flex-wrap justify-center items-center content-center">
        <div :class="source[1]" class="my-2 px-4" :key="index" v-for="(source, index) in this.images">
          <img :class="source[2]" :src="source[0]">
        </div>
      </div>
      <br>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AchievementPopup',
  props: {
    title: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    attachmentOne: {
      type: Object,
      required: false
    },
    attachmentTwo: {
      type: Object,
      required: false
    },
    desc: {
      type: String,
      required: false
    },
    images: {
      type: Array,
      required: false
    }
  },
  created: function () {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
  },
  unmounted: function () {
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
  }
}
</script>

<style scoped>
img {
  transition-duration: 0.5s;
  transform: scale(1);
}

img:hover {
  transition-duration: 1s;
  transform: scale(1.2);
}
</style>
